import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { 
    VerifiedUser as VerifiedUserIcon,
    PersonAdd as PersonAddIcon,
    Group as GroupIcon
} from '@mui/icons-material';
import { Modal, TextInput, Text, Services, Button, ContainerControlSite, ContentBlock, Content } from '@simplybenefits/sb-ui-library';

import Header from '../../components/Header.js';

import MemberRow from './MemberRow.js';
import PermissionsItem from './PermissionsItem.js';
import permissionLevel, { permissions } from '../../services/permissions.js';
import { checkEmail } from '../../services/helpers.js';
import { getMasterUsers, removeMasterUser, setMasterPermission, addMasterUser } from '../../actions/master.js';
import { styled } from '@mui/system';

const ContentLeftAndRight = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '50%',
    maxWidth: '50%',
    [theme.breakpoints.up('md')]: {
        minWidth: '50%'
    },
    [theme.breakpoints.down('md')]: {
        minWidth: '100%',
        maxWidth: '100%'
    }
}));

const Columns = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column'
    }
}));

class Permissions extends PureComponent {
    state = {
        firstname: '',
        lastname: '',
        email: '',
        masterEmail: '',
        modalOpen: false,
        userList: [],
        showUserList: true,
        selectedUser: false,
        permissionOptions: [],
        newPermission: '',
        expanded: []
    };

    static getDerivedStateFromProps(props, state) {
        if (!permissionLevel('Master Site Management', props.accessType).includes('write') ||
            (props.email && !checkEmail(props.email))
        ) {
            window.location.href = '/403';
        }

        // Look at these lovely blocks : ) Your welcome
        if (props.email && props.email !== state.masterEmail) {
            return { masterEmail: props.email };
        }

        if (props.users && props.users !== state.userList) {
            return { userList: props.users };
        }

        return null;
    }

    async componentDidMount() {
        await this.props.dispatch(getMasterUsers());
        const permissionOptions = Object.keys(permissions.Adjudication).map((item) => item);

        this.setState({
            userList: this.props.users || [],
            permissionOptions
        });
    }

    _onBlur = async (type) => {
        this.setState({
            [`${ type }Error`]: await Services.validateInput('checkEmpty', this.state[type])
        });
    };

    _handleInputChange = (type, event) => {
        this.setState({
            [type]: event.target.value
        });
    };

    _add = async () => {
        const data = {
            firstname: this.state.firstname.trim(),
            lastname: this.state.lastname.trim(),
            email: this.state.email.trim(),
            access: this.state.newPermission.trim()
        };

        const success = await this.props.dispatch(addMasterUser(data));

        if (success) {
            this._toggleModal();

            this.setState({
                firstname: '',
                lastname: '',
                email: '',
                access: ''
            });
        }
    };

    _change = async () => {
        const success = await this.props.dispatch(setMasterPermission(this.state.selectedUser.masterID, this.state.newPermission));

        if (success) {
            this._toggleModal();
        }
    };

    _remove = async () => {
        const success = await this.props.dispatch(removeMasterUser(this.state.selectedUser.masterID));

        if (success) {
            this._toggleModal();
        }
    };

    _toggleModal = (user = false, type = false) => {
        this.setState({
            modalOpen: type,
            selectedUser: user
        });
    };

    _toggleShowUserList = () => {
        this.setState({
            showUserList: !this.state.showUserList
        });
    };

    _openAccordion = (panel) => (event, expanding) => {
        let expanded = [ ...this.state.expanded ];
        const index = expanded.indexOf(panel);

        if (expanding && index === -1) {
            expanded.push(panel);
        } else {
            expanded.splice(index, 1);
        }

        this.setState({
            expanded
        });
    };

    render() {
        const { userList, selectedUser, permissionOptions, showUserList, expanded } = this.state;

        const styles = {
            buttonRow: {
                display: 'flex',
                justifyContent: 'flex-end',
                flexWrap: 'wrap',
                marginBottom: 20
            }
        };

        const left = [];
        const right = [];

        const employee = {
            firstname: 'Member',
            lastname: 'Name',
            email: '',
            access: 'Permission Level'
        };

        permissionOptions.map((level, index) => {
            index % 2 === 0 ?
                left.push({ title: level, content: permissions })
                :
                right.push({ title: level, content: permissions });

            return null;
        });

        return (
            <>
                <ContainerControlSite background={"true"}>
                    <Header
                        subHeader="Permissions"
                        selectedTitle="reports"
                    />

                    <Content>
                        <div style={styles.buttonRow}>
                            {showUserList ?
                                <Button
                                    onClick={this._toggleShowUserList}
                                    transparent
                                >
                                    <VerifiedUserIcon />&nbsp;Permissions Details
                                </Button>
                                :
                                <Button
                                    onClick={this._toggleShowUserList}
                                    transparent
                                >
                                    <GroupIcon />&nbsp;Manage Users
                                </Button>
                            }

                            <Button
                                onClick={() => this._toggleModal('', 'add')}
                                transparent
                            >
                                <PersonAddIcon />&nbsp;New Master User
                            </Button>
                        </div>
                        {
                            showUserList ?
                                <>
                                    <MemberRow
                                        blank
                                        employee={employee}
                                    />

                                    {userList.map((user) => (
                                        <MemberRow
                                            key={user.masterID}
                                            employee={user}
                                            change={() => this._toggleModal(user, 'change')}
                                            remove={() => this._toggleModal(user, 'remove')}
                                        />
                                    ))}
                                </>
                                :
                                <>
                                    <ContentBlock>
                                        <Columns>
                                            <ContentLeftAndRight>
                                                {
                                                    left.map((section) => (
                                                        <PermissionsItem
                                                            key={section.title}
                                                            section={section}
                                                            expanded={expanded}
                                                            openAccordion={this._openAccordion}
                                                        />
                                                    ))
                                                }
                                            </ContentLeftAndRight>

                                            <ContentLeftAndRight>
                                                {
                                                    right.map((section) => (
                                                        <PermissionsItem
                                                            key={section.title}
                                                            section={section}
                                                            expanded={expanded}
                                                            openAccordion={this._openAccordion}
                                                        />
                                                    ))
                                                }
                                            </ContentLeftAndRight>
                                        </Columns>
                                    </ContentBlock>
                                </>
                        }
                    </Content>

                    <span id="permissions" />
                </ContainerControlSite>

                <Modal
                    title="Add Master User"
                    open={this.state.modalOpen === 'add'}
                    small
                    onBack={this._toggleModal}
                    onClose={this._toggleModal}
                    primaryButton={{
                        label: "Add",
                        onClick: this._add
                    }}
                    loader={this.props.loader}
                >
                    <TextInput
                        label="Firstname"
                        value={this.state.firstname}
                        onBlur={() => this._onBlur('firstname')}
                        onChange={(value) => this._handleInputChange('firstname', value)}
                        error={Boolean(this.state.firstnameError)}
                        helperText={this.state.firstnameError}
                        fullWidth
                        autoFocus
                    />

                    <TextInput
                        label="Lastname"
                        value={this.state.lastname}
                        onBlur={() => this._onBlur('lastname')}
                        onChange={(value) => this._handleInputChange('lastname', value)}
                        error={Boolean(this.state.lastnameError)}
                        helperText={this.state.lastnameError}
                        fullWidth
                    />

                    <TextInput
                        label="Email"
                        value={this.state.email}
                        onBlur={() => this._onBlur('email')}
                        onChange={(value) => this._handleInputChange('email', value)}
                        error={Boolean(this.state.emailError)}
                        helperText={this.state.emailError}
                        fullWidth
                    />

                    <TextInput
                        label="Permission type"
                        variant="outlined"
                        value={this.state.newPermission}
                        onBlur={() => this._onBlur('newPermission')}
                        onChange={(value) => this._handleInputChange('newPermission', value)}
                        error={Boolean(this.state.newPermissionError)}
                        helperText={this.state.newPermissionError}
                        fullWidth
                        required
                        select
                        selectOptions={[ ...permissionOptions ]}
                    />
                </Modal>

                <Modal
                    title="Edit Permission"
                    open={this.state.modalOpen === 'change'}
                    onClose={this._toggleModal}
                    onBack={this._toggleModal}
                    primaryButton={{
                        label: "Save",
                        onClick: this._change
                    }}
                    loader={this.props.loader}
                >
                    <Text
                        medium
                        display="block"
                    >
                        { `${ selectedUser.firstname } - ${ selectedUser.access }` }
                    </Text>

                    <TextInput
                        label="New Permission"
                        variant="outlined"
                        value={this.state.newPermission || selectedUser.access}
                        onBlur={() => this._onBlur('newPermission')}
                        onChange={(value) => this._handleInputChange('newPermission', value)}
                        error={Boolean(this.state.newPermissionError)}
                        helperText={this.state.newPermissionError}
                        fullWidth
                        required
                        select
                        selectOptions={[ ...permissionOptions ]}
                    />
                </Modal>

                <Modal
                    title="Remove this user from Master Site?"
                    open={this.state.modalOpen === 'remove'}
                    onClose={this._toggleModal}
                    onBack={this._toggleModal}
                    primaryButton={{
                        label: "Remove",
                        onClick: this._remove
                    }}
                    loader={this.props.loader}
                >
                    <Text
                        medium
                        display="block"
                    >
                        They will no longer have access to the Master Site at all. If you wish that they had different permissions, choose "Change Permission" from the menu.
                    </Text>
                </Modal>
            </>
        );
    }
}

Permissions.propTypes = {
    accessType: PropTypes.string,
    email: PropTypes.string,
    users: PropTypes.array
};

/**
 * @param state
 * @returns {{loading: *}}
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    accessType: state.master.access,
    email: state.master.email,
    users: state.master.users
});

export default connect(mapStateToProps)(Permissions);